import { useQuery } from '@tanstack/react-query';
import { fetchBillingUsage } from '../api/billingApi';

export default function useBillingUsage() {
    return useQuery({
        queryKey: ['billingUsage'],
        queryFn: fetchBillingUsage,
        staleTime: 30 * 1000,
    });
}
